/* eslint-disable */
import ls from 'local-storage';
import 'jquery.cookie';
import 'jcarousel';

import gaAsync from '@/js/common/Domain/Service/gaAsync';
import searchSessionService from '@/js/common/Domain/Service/search/searchSession';
import imageProxy from '@/js/common/Domain/Service/imageProxy';
import toRouterHotelHydrator from '@/js/common/Domain/Hydrator/toRouterHotel';
import trackingService from '@/js/common/Domain/Service/tracking/tracking';
import mindBoxService from '@/js/common/Service/mindBoxService/MindBoxServiceDesktop';

import IsExclusiveBlock from '@ve/components/hotel/isExclusiveBlock/desktop/isExclusiveBlock.vue';
import '@/js/desktop/View/searchPageHotel/serpHotelCard/serpHotelCard.scss';
import '@/js/common/components/reviewsColor/reviewsColor.css';

import '@/css/desktop/tooltip.scss';

import '@/js/desktop/components/search/useFilters/styles/useFilters.css';
import '@/js/desktop/components/search/useFilters/styles/useFiltersBnr.scss';

import CashbackHotelCardBannerView from '@/js/desktop/components/cashbackHotelCardBanner/cashbackHotelCardBanner';

import trackImageErrors from '@/js/common/Domain/Service/trackImageErrors';

import TooltipPopoverHtml from '@/js/common/components/tooltip/htmlTooltip/HtmlTooltip';

import firstPaymentDefinitionService from '@/js/common/Domain/Service/firstPaymentDefinition';

import { createApp } from '@vue/composition-api';
import PartialPaymentBannerForProductCard
    from '@ve/components/partialPayment/partialPaymentBannerForProductCard/desktop/PartialPaymentBannerForProductCard.vue';
import CashbackPartialPaymentBannerForProductCard
    from '@ve/components/partialPayment/cashbackPartialPaymentBannerForProductCard/desktop/CashbackPartialPaymentBannerForProductCard.vue';
import checkProductCashbackAvailable from '@/js/common/Domain/Service/checkProductCashbackAvailable';

import template from './searchPageHotelOffers/hotelTemplate.html';
import '@/css/common/components/warranted-icon.scss';

export default Backbone.Epoxy.View.extend({
    el: '<div class="serpHotelCard"></div>',
    data: null,
    template,
    events: {
        'click .goToHotelWithId': 'goToHotelWithId',
        'click .goToHotel': 'goToHotel',
        'mousedown .serpHotelCard__container a:not(.goto-ua-page, .notChange)': 'hotelClick',
    },
    trackingHotelClick() {
        trackingService.trackSerpHotelPosition({
            hotels: this.collectionView.collection,
            selectedHotel: this.model,
            sortStrategy: this.collectionView.model.get('sortStrategy'),
        });

        mindBoxService.trackViewSerpClick('serp_hotel', {
            searhPageModel: this.model,
            collectionViewModel: this.collectionView.model,
        });
    },
    hotelClick(e) {
        this.trackingHotelClick();
        this.hrefUrl(e);
    },
    generateImagesHtml({ cover, photos }) {
        let html = '';
        const images = [].concat(
            cover || [],
            photos || [],
        );

        if (images?.length) {
            _.each(images, (photo) => {
                html += `<li><a href="#" data-src="${imageProxy(photo, {
                    width: 300,
                    height: 220,
                })}"></a></li>`;
            });

            const randomPhoto = images[Math.round(Math.random() * (images.length - 1))];
            html += `<li class="lastPhotoLink"><a class="img" href="#" data-src="${imageProxy(randomPhoto, {
                width: 300,
                height: 220,
            })}"></a><a href="#" class="btn">Смотреть все фото</a></li>`;
        }

        return html;
    },
    renderPhotos() {
        let imagesHtml = this.model.get('imagesHtml');
        const $modelElement = this.$el;
        const $imagesPlace = $('.imagesHtml', $modelElement);
        const $carousel = $('.js-images-carousel', $modelElement);

        if (!imagesHtml) {
            imagesHtml = this.generateImagesHtml({
                cover: this.model.get('cover'),
                photos: this.model.get('photos'),
            });
            this.model.set('imagesHtml', imagesHtml);
        }

        if (imagesHtml) {
            if ($imagesPlace.length) {
                $imagesPlace.html(imagesHtml);
            }

            if (_.isObject($carousel.data('jcarousel'))) {
                $carousel.jcarousel('reload', {
                    animation: 'fast',
                });
                $carousel.jcarousel('scroll', 0, false);
            }
        }
    },
    selectTemplate() {
        return this.template;
    },
    render() {
        let template;
        const self = this;
        const data = this.model.toJSON({ computed: true });
        const hotelIndex = self.collectionView.collection.indexOf(self.model);

        if (self.collectionView) {
            template = this.selectTemplate();
        }

        data.originalHotelObject = this.model;

        data.hotelIndex = hotelIndex;

        if (this.hotelMapView) {
            this.hotelMapView.reRender({
                data,
                $el: this.$el,
                parentModel: this.model,
                collectionView: this.collectionView,
            });
        } else {
            this.$el.html(template(data));
        }

        setTimeout(() => {
            self.applyBindings();
        }, 0);

        this.data = data;

        this.initCarousel();
        this.renderPhotos();
        this.initSubViews();
        this.initVueComponents();

        this.showBottomBanner();
    },

    showBottomBanner() {
        const { isVisible: isVisiblePartialPayment } = this.getPartialPaymentData();

        const hasTourCashbackAvailable = checkProductCashbackAvailable(this.model.get('hotelOffers'));

        const isCashbackAvailable = window?.appConfig?.cashbackAvailable
            && hasTourCashbackAvailable;

        if (isCashbackAvailable) {
            if (isVisiblePartialPayment) {
                this.initCashbackPartialPaymentBanner();
                return;
            }
            this.initCashbackBanner();
            return;
        }

        if (isVisiblePartialPayment) {
            this.initPartialPaymentBanner();
        }
    },

    getPartialPaymentData() {
        const hotelOffers = this.model.get('hotelOffers');
        const hotelOffer = hotelOffers?.at(0);
        const firstPaymentDefinitions = firstPaymentDefinitionService.getData();

        const isVisible = !!hotelOffer.get('firstPaymentDefinition')?.id && firstPaymentDefinitions.length > 0;
        const countryName = this.model.get('country').get('name');

        return {
            isVisible,
            countryName,
            hotelOffers,
        };
    },

    initPartialPaymentBanner() {
        const { countryName, hotelOffers } = this.getPartialPaymentData();
        this.$el.addClass('partialPayment');

        this.partialPaymentBanner = createApp(PartialPaymentBannerForProductCard, {
            countryName,
            products: hotelOffers.toJSON(),
            productType: 'hotelOffer',
        }).mount(this.$el.find('.partialPayment__banner').get(0));
    },

    initCashbackPartialPaymentBanner() {
        const { countryName, hotelOffers } = this.getPartialPaymentData();
        this.$el.addClass('cashbackPartialPayment');

        this.cashbackPartialPaymentBanner = createApp(CashbackPartialPaymentBannerForProductCard, {
            countryName,
            products: hotelOffers.toJSON(),
            productType: 'hotelOffer',
        }).mount(this.$el.find('.cashbackPartialPayment__banner').get(0));
    },

    initCashbackBanner() {
        //hotel serp
        new CashbackHotelCardBannerView({
            el: $('.serpHotelCard__container', this.$el),
            productType: 'hotelOffer',
        });
    },

    initSubViews() {
        this.warrantyTooltip = new TooltipPopoverHtml({
            el: $('.js-warranted-icon', this.$el),
        });
    },
    initVueComponents() {
        const isExclusive = this.model.get('isExclusive');
        if (isExclusive) {
            this.IsExclusiveBlockVueComponent = new IsExclusiveBlock({
                el: $('.js-serpHotelCard__isExclusive', this.$el).get(0),
                propsData: {
                    isExclusive,
                },
            });
        }
    },
    initCarousel() {
        $('.js-images-carousel', this.$el).jcarousel({
            list: '.list',
            items: 'li',
            wrap: 'both',
            vertical: false,
        }).on('jcarousel:visiblein', 'li', function () {
            const $element = $('a:not(.btn)', this);
            const imageUrl = $element.data('src');

            $element.css('background-image', `url("${imageUrl}")`);
            trackImageErrors([imageUrl]);
        });

        $('.js-images-carousel-control-prev', this.$el).jcarouselControl({
            target: '-=1',
        });

        $('.js-images-carousel-control-next', this.$el).jcarouselControl({
            target: '+=1',
        });
    },
    reRender(model) {
        this.render();
    },

    initSubscribes() {
        this.listenTo(this.model, 'change:minPrice', $.proxy(this.reRender, this));
        this.listenTo(this.model, 'change:hotelOffers', $.proxy(this.reRender, this));
    },
    initialize(options) {
        this.collectionView = options.collectionView;
        this.hotelMapView = options.hotelMapView;

        this.render();
        this.initSubscribes();
    },
    hrefUrl(event) {
        const hotelOffer = this.model.get('hotelOffers').at(0);
        const identity = $(event.currentTarget).data('identity') || hotelOffer.get('id');
        const urlParams = toRouterHotelHydrator({
            tourCriteria: hotelOffer.get('tourCriteria'),
            similar: !!this.model.get('similar'),
            productType: 'hotelOffer',
            identity,
            minPrice: this.model.get('minPrice'),
            operatorId: hotelOffer.get('operator').id,
            sid: searchSessionService.getSearchId(),
            suuid: trackingService.getSearchUuid(),
        });
        const hotelUrl = this.model.get('url');
        const target = ($('.oneColumn:visible').length) ? '_self' : '_blank';
        const $target = $(event.currentTarget);

        if (typeof identity !== 'undefined') {
            if (event.which === 2) {
                gaAsync(() => {
                    ga('send', 'event', 'Hotel_Card', 'Visit_the_hotel', 'date_price', { nonInteraction: 1 });
                });
            }
        } else if (event.which === 2 && $target.parent().parent().parent().hasClass('serpHotel_Image')) {
            gaAsync(() => {
                ga('send', 'event', 'Hotel_Card', 'Visit_the_hotel', 'image_hotel', { nonInteraction: 1 });
            });
        }
        if ($target.hasClass('distance')) {
            urlParams.toMap = true;
        }
        $(event.currentTarget).attr('href', `${hotelUrl}#?${$.param(urlParams)}`);
        $(event.currentTarget).attr('target', target);
        ls.set('isAbsent', false);
    },
    goToHotelWithId(event) {
        const identity = $(event.currentTarget).data('identity') || hotelOffer.get('id');
        const hotelOffer = this.model.get('hotelOffers').findWhere({ id: identity });
        const tourCriteria = typeof (hotelOffer) === 'undefined' ? null : hotelOffer.get('tourCriteria');

        if (tourCriteria !== null) {
            const urlParams = toRouterHotelHydrator({
                tourCriteria,
                productType: 'hotelOffer',
                identity,
                minPrice: this.model.get('minPrice'),
                operatorId: hotelOffer.get('operator').id,
                sid: searchSessionService.getSearchId(),
                suuid: trackingService.getSearchUuid(),
            });
            const target = ($('.oneColumn:visible').length) ? '_self' : '_blank';
            const hotelUrl = this.model.get('url');

            window.open(`${hotelUrl}#?${$.param(urlParams)}`, target);
            ls.set('isAbsent', false);
        }
        return false;
    },
    goToHotel(event) {
        const hotelOffer = this.model.get('hotelOffers').at(0);
        const identity = $(event.currentTarget).data('identity') || hotelOffer.get('id');
        const tourCriteria = hotelOffer.get('tourCriteria');
        const urlParams = toRouterHotelHydrator({
            tourCriteria,
            productType: 'hotelOffer',
            identity,
            minPrice: this.model.get('minPrice'),
            operatorId: hotelOffer.get('operator').id,
            sid: searchSessionService.getSearchId(),
            suuid: trackingService.getSearchUuid(),
        });
        const $target = $(event.currentTarget);
        const target = ($('.oneColumn:visible').length) ? '_self' : '_blank';
        const hotelUrl = this.model.get('url');

        if ($target.hasClass('distance')) {
            urlParams.toMap = true;
        }
        if ($target.hasClass('hotel-reviews')) {
            urlParams.toReviews = true;
        }
        window.open(`${hotelUrl}#?${$.param(urlParams)}`, target);
        ls.set('isAbsent', false);
        return false;
    },
});
